import React from 'react';
import './documents.scss';

import { TabPanel, Item } from 'devextreme-react/tab-panel';

import {useCallback} from "react";

import CompanyDocs from './companyDocs.js';
import CollaboratorDocs from './collaboratorDocs.js';
import ProjectsDocs from './projectDocs.js';

const AREA_COMPANY = 1;
const AREA_COLLABORATOR = 2;
const AREA_PROJECT = 3;
export default function Documents() {



  function renderCompanyTab() {
    return <CompanyDocs area = {AREA_COMPANY} />;
  }
   
  function renderCollaboratorTab() {
    return <CollaboratorDocs area = {AREA_COLLABORATOR}/>;
  }
 
  function renderProjectTab() {  
    return <ProjectsDocs area = {AREA_PROJECT}/>;
  }

  const onTabSelectionChanged = useCallback((e) => {
    //notify("The button was clicked");
    ;
  }, []);

  return (
  <React.Fragment>
    <h2 className={'content-block'}>Documenti</h2>
    <div className={'content-block'}>
      <div className={'dx-card responsive-paddings'}>
        
      <div>
      
      <TabPanel    
          onSelectionChanged={onTabSelectionChanged}
      >
          <Item title="Azienda" render={renderCompanyTab} />
          <Item title="Collaboratore" render={renderCollaboratorTab} />
          <Item title="Commessa" render={renderProjectTab} />
      </TabPanel>
       
  </div>  

      </div>
    </div>
  </React.Fragment>
)};
